<template>
    <div class="edit_point"  v-if="addOk">
        <el-card class="edit_point_account">
           <div slot="header" class="clearfix">
                <span>账号安全</span>
            </div>
            <div style="color:red;">
                <p>系统检测到你还从未修改过密码</p>
                <p>建议你修改密码</p>
            </div>
            <el-button type="success" @click="changePwd">修改密码</el-button>
        </el-card>
    </div>
</template>
<script>
    export default {
      props: ['addShow', 'userAcc', 'userName', 'userId'],
      data () {
        return {
        }
      },
      computed: {
        addOk: function () {
          return this.addShow
        },
        myuserAcc: function () {
          return this.userAcc
        },
        myuserName: function () {
          return this.userName
        },
        myuserId: function () {
          return this.userId
        }
      },
      methods: {
        changePwd () {
          this.$emit('closefirstPu', false)
          this.$router.push({path: '../accountMgr/editPwd', query: {'acc': this.myuserAcc, 'name': this.myuserName, 'id': this.myuserId}})
        }
      }
    }
</script>
<style lang="scss">
  .edit_point {
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      position: fixed;
      background: rgba(#000, 0.3);
      z-index: 100;
      text-align: center;
  }
  .edit_point_account {
        min-height: 330px;
        width: 700px;
        top: 10%;
        left: 50%;
        z-index: 101;
        margin-left: -350px;
        position: fixed;

    .editContent {
      text-align: left;
      margin-left: 30px; 

      .el-input{
        width: 300px;
      }
      .e_left {
          width: 20%;
          display: inline-block;
      }
    }
  }
</style> 


// WEBPACK FOOTER //
// src/page/deviceMgr/judgeFirstLogin.vue